<template>
	<div class="pb-30">
		<md-card class="mt-20">
			<md-card-header class="ask-subject" :style="communityStyle" v-html="sanitizeInput($lodash.has(community, 'name') ? community.name + ': ' + ask.subject : ask.subject)">
			</md-card-header>
		</md-card>
		<ask-detail class="mt-30" :ask="ask" v-on:chosen="addSeeker">Ask detail goes here...</ask-detail><!--editAsk="true"-->
		<md-card class="mt-30">
			<md-card-content>
				<md-field>
					<label class='edit-label'>Title</label>
					<md-input class="input-subject" v-model="ask.subject" @input="ask.subject = sanitizeInput($event)"></md-input>
					<span class="md-helper-text">Remember to make it descriptive</span>
				</md-field>
				<md-field class="textareaAfter">
					<label class='edit-label'>Text</label>
					<md-textarea class="input-textarea" v-model="ask.text" @input="ask.text = sanitizeInput($event)" md-autogrow></md-textarea>
				</md-field>
				<md-ripple>
					<base-interaction-button :interaction="action" @interact="doInteraction">{{ action }}</base-interaction-button>
				</md-ripple>
			</md-card-content>
		</md-card>
		<ask-feedback class="mt-30" :ask="ask">Feedback goes here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log>
	</div>
</template>

<!-- Script-->
<script>
import API from "../services/API";
import ActivityLog from "./ActivityLog";
import Comments from "./Comments";
import AskDetail from "./AskDetail";
import AskFeedback from "./AskFeedback";
import { sanitizeInput } from '@/utils/sanitizer';

export default {
  components: {
    ActivityLog,
    Comments,
    AskDetail,
    AskFeedback
  },
  data() {
    return {
      api: new API(),
      ask: {},
      action: "edit",
      createdByMember: {},
      communityStyle: {
        backgroundColor: "white",
        color: "black"
      },
      community: {}
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    sanitizeInput(event) {
      return sanitizeInput(event);
    },
    loadData: async function() {
      // console.log("Checking: ", this.action);
      await this.api.get(`asks/${this.$route.params.ask_id}`).then(ask => {
        // console.log("Got back", ask);
        this.ask = ask.data;
        if (this.ask) {
	    	// this.api.get(`communities/${this.ask.community}`).then(community => {
	      	  this.community = this.ask.community;
	          if (this.$lodash.has(this.community, 'customSettings')) {
	          	this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
	          	this.communityStyle.color = this.community.customSettings.secondaryColor;
	          }
	    	// });
          	this.getCreatedBy();
        }
      });
    },
    getCreatedBy: function() {
      this.createdByMember = this.ask.createdByMemberID;
      // this.api.get(`members/${this.ask.createdByMemberID}`).then(member => {
      //   this.createdByMember = member.data;
      // });
    },
    addSeeker: function(members) {
      this.ask.createdByMemberID = members[0];
      this.getCreatedBy();
    },
    doInteraction: async function() {
      await this.api
        .put(`asks/${this.ask._id}/${this.action}`, {
          ask: this.ask
        })
        .then(response => {
          this.$emit("reload");
          this.$router.push(`/`);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InteractEdit.vue